import React, {
    useState,
    useEffect
} from 'react';


import {
    useDispatch,
    useSelector
} from 'react-redux';


import date
    from 'date-and-time';


import {

    actividadesAgendadasSolicitarAction,
    actividadesAgendarAction,
    actualizarActividadesAction,
    actualizarInfoActividadesAction

} from '../../actions/actividadesActions';


import useConfigAuth
    from '../../Hooks/useConfigAuth';


// css
import {

    ContenedorSeleccionadas,
    TituloSeleccionadas,

    ListaSeleccionadas,
    FilaSeleccionada,
    NombreActividadSeleccionada,

    BotonEliminarSeleccionada,

    ContadorActividad,
    BotonContador,
    ValorContador,

    ControlesOrden,
    BotonOrden,

    SinActividadesSeleccionadas,

    BarraAgendado,
    CampoAgendado,
    LabelAgendado,
    InputFechaAgendado,
    ValorAgendado,
    BotonAgendarActividad

} from '../Css/StyledActividadesDomicilio';



const SeleccionarActividadesSeleccionadas = () => {


    const dispatch =
        useDispatch();


    const [
        config
    ] = useConfigAuth();


    const infoActividades =
        useSelector(
            (state) =>
                state.informacion.info_actividades
        );


    const {
        actividades
    } = infoActividades;


    const seleccionadas =
        useSelector(
            (state) =>
                state.actividades.seleccionadas
        );


    const id_paciente =
        useSelector(
            (state) =>
                state.usuario.id_paciente
        );


    const correcto =
        useSelector(
            (state) =>
                state.estado.correcto
        );


    const [
        tiempoSesion,
        setTiempoSesion
    ] = useState(
        '0 min 0 seg'
    );


    const [
        fechaSesion,
        setFechaSesion
    ] = useState(
        ''
    );


    const [
        actividadesSeleccionadas,
        setActividadesSeleccionadas
    ] = useState(
        seleccionadas
    );



    /*
    ====================================
    NOMBRE COMPLETO DE ACTIVIDAD
    ====================================
    */

    const obtenerNombreActividad =
        (actividad) => {


            if (
                actividad.ultimo ===
                'cinco'
            ) {

                return `${actividad.uno} - ${actividad.dos} - ${actividad.tres} - ${actividad.cuatro} - ${actividad.cinco}`;

            }


            if (
                actividad.ultimo ===
                'cuatro'
            ) {

                return `${actividad.uno} - ${actividad.dos} - ${actividad.tres} - ${actividad.cuatro}`;

            }


            if (
                actividad.ultimo ===
                'tres'
            ) {

                return `${actividad.uno} - ${actividad.dos} - ${actividad.tres}`;

            }


            if (
                actividad.ultimo ===
                'dos'
            ) {

                return `${actividad.uno} - ${actividad.dos}`;

            }


            return actividad.uno;

        };



    /*
    ====================================
    CANTIDAD
    ====================================
    */

    const actualizarContador = (
        e,
        id,
        tipo
    ) => {


        e.preventDefault();


        const actualizoInfoActividades =
            JSON.parse(
                JSON.stringify(
                    infoActividades
                )
            );


        let iActividades =
            actualizoInfoActividades.actividades.findIndex(
                item => {

                    return item.id === id;

                }
            );


        if (
            tipo ===
            "disminuir"
        ) {

            if (
                actualizoInfoActividades
                    .actividades[
                        iActividades
                    ]
                    .contador ===
                0
            ) {

                return;

            }


            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .contador--;

        } else {

            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .contador++;

        }


        dispatch(
            actualizarInfoActividadesAction(
                actualizoInfoActividades
            )
        );

    };



    /*
    ====================================
    ELIMINAR
    ====================================
    */

    const eliminarActividad = (
        e,
        id
    ) => {


        e.preventDefault();


        const actualizoInfoActividades =
            JSON.parse(
                JSON.stringify(
                    infoActividades
                )
            );


        const actividadSeleccionada =
            JSON.parse(
                JSON.stringify(
                    seleccionadas
                )
            );


        let iActividades =
            actualizoInfoActividades.actividades.findIndex(
                item => {

                    return item.id === id;

                }
            );


        actualizoInfoActividades
            .actividades[
                iActividades
            ]
            .seleccionado =
                false;


        actualizoInfoActividades
            .actividades[
                iActividades
            ]
            .contador =
                1;


        let numero =
            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .ultimo;


        for (
            let obj
            of actualizoInfoActividades[
                numero
            ]
        ) {

            if (
                obj.id ===
                id
            ) {

                obj.color =
                    false;

            }

        }


        let index =
            actividadSeleccionada.indexOf(
                id
            );


        actividadSeleccionada.splice(
            index,
            1
        );


        dispatch(
            actualizarActividadesAction(
                actividadSeleccionada
            )
        );


        dispatch(
            actualizarInfoActividadesAction(
                actualizoInfoActividades
            )
        );


        setActividadesSeleccionadas(
            actividadSeleccionada
        );

    };



    /*
    ====================================
    ORDEN
    ====================================
    */

    const modificoOrden = (
        e,
        i,
        movimiento
    ) => {


        e.preventDefault();


        const newList =
            JSON.parse(
                JSON.stringify(
                    actividadesSeleccionadas
                )
            );


        if (
            movimiento ===
            'disminuir'
        ) {

            let item =
                newList.splice(
                    i,
                    1
                )[0];


            newList.splice(
                i - 1,
                0,
                item
            );


            setActividadesSeleccionadas(
                newList
            );

        } else {

            let item =
                newList.splice(
                    i,
                    1
                )[0];


            newList.splice(
                i + 1,
                0,
                item
            );


            setActividadesSeleccionadas(
                newList
            );

        }

    };



    /*
    ====================================
    AGENDAR
    ====================================
    */

    const actividadesAgendar = (
        e
    ) => {


        e.preventDefault();


        const actualizoInfoActividades =
            JSON.parse(
                JSON.stringify(
                    infoActividades
                )
            );


        const agendar =
            JSON.parse(
                JSON.stringify(
                    infoActividades
                )
            )
                .actividades
                .filter(
                    obj =>
                        obj.seleccionado ===
                            true &&
                        obj.contador >
                            0
                );


        const fechaHoy =
            new Date();


        const hora =
            fechaHoy.getHours();


        const minutos =
            fechaHoy.getMinutes() +
            1;


        let fechaFinalSesion;


        if (
            fechaSesion
        ) {

            fechaFinalSesion =
                fechaSesion;

        } else {

            const hoy =
                new Date();


            const fechaHoyFormateada =
                hoy
                    .toISOString()
                    .split(
                        'T'
                    )[0];


            fechaFinalSesion =
                fechaHoyFormateada;

        }


        const formatFechaSesion =
            `${fechaFinalSesion} ${hora}:${minutos}`;


        const fechaElegida =
            new Date(
                formatFechaSesion
            );


        const fecha_agendada =
            date.format(
                fechaElegida,
                'YYYY-MM-DD'
            );


        if (
            agendar.length ===
                0 ||
            fechaSesion ===
                '' ||
            fechaElegida <
                fechaHoy
        ) {

            return;

        }


        const payload =
            [];


        for (
            let i = 0;
            i < agendar.length;
            i++
        ) {


            let orden =
                actividadesSeleccionadas.indexOf(
                    agendar[i].id
                ) + 1;


            const obj = {

                'ejercicio_id':
                    agendar[i].id,

                'nombre_mostrar':
                    agendar[i].nombre_mostrar,

                'cantidad':
                    agendar[i].contador,

                'fecha_agendada':
                    fecha_agendada,

                'url':
                    agendar[i].url,

                'lista':
                    agendar[i].lista,

                'letra':
                    agendar[i].letra,

                id_paciente,

                'orden':
                    orden

            };


            payload.push(
                obj
            );

        }


        const informacion = {

            config,

            payload

        };


        for (
            let i = 0;
            i < seleccionadas.length;
            i++
        ) {


            let iActividades =
                actualizoInfoActividades.actividades.findIndex(
                    item => {

                        return item.id ===
                            seleccionadas[i];

                    }
                );


            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .seleccionado =
                    false;


            actualizoInfoActividades
                .actividades[
                    iActividades
                ]
                .contador =
                    1;


            let numero =
                actualizoInfoActividades
                    .actividades[
                        iActividades
                    ]
                    .ultimo;


            let iNumero =
                actualizoInfoActividades[
                    numero
                ]
                    .findIndex(
                        item => {

                            return item.id ===
                                seleccionadas[i];

                        }
                    );


            actualizoInfoActividades[
                numero
            ][
                iNumero
            ]
                .color =
                    false;

        }


        let actividadSeleccionada =
            [];


        dispatch(
            actualizarActividadesAction(
                actividadSeleccionada
            )
        );


        dispatch(
            actualizarInfoActividadesAction(
                actualizoInfoActividades
            )
        );


        dispatch(
            actividadesAgendarAction(
                informacion
            )
        );


        setActividadesSeleccionadas(
            []
        );


        setFechaSesion(
            ''
        );

    };



    /*
    ====================================
    CALCULAR TIEMPO
    ====================================
    */

    useEffect(
        () => {


            const seleccionados =
                actividades.filter(
                    obj =>
                        obj.seleccionado ===
                        true
                );


            let tiempo =
                0;


            for (
                let i = 0;
                i <
                    seleccionados.length;
                i++
            ) {

                tiempo +=
                    (
                        seleccionados[i]
                            .tiempo
                    ) *
                    seleccionados[i]
                        .contador;

            }


            let minutos =
                tiempo /
                60;


            let minutofinal =
                Math.floor(
                    minutos
                );


            let segundos =
                (
                    minutos -
                    minutofinal
                ) *
                60;


            let segundosFinal =
                Math.round(
                    segundos
                );


            setTiempoSesion(
                `${minutofinal} min ${segundosFinal} seg`
            );


            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            infoActividades
        ]
    );



    /*
    ====================================
    RECARGAR AGENDADAS
    ====================================
    */

    useEffect(
        () => {


            if (
                correcto
            ) {

                const informacion = {

                    config,

                    payload: {

                        id_paciente

                    }

                };


                dispatch(
                    actividadesAgendadasSolicitarAction(
                        informacion
                    )
                );

            }


            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            correcto
        ]
    );



    return (

        <ContenedorSeleccionadas>


            <TituloSeleccionadas>

                Actividades seleccionadas

            </TituloSeleccionadas>


            <ListaSeleccionadas>


                {
                    actividadesSeleccionadas.length ===
                    0
                        ?

                        <SinActividadesSeleccionadas>

                            Todavía no seleccionaste actividades.

                        </SinActividadesSeleccionadas>

                        :

                        actividadesSeleccionadas.map(
                            (
                                ejercicio,
                                index
                            ) => {


                                const actividad =
                                    actividades.find(
                                        item =>
                                            item.id ==
                                            ejercicio
                                    );


                                if (
                                    !actividad
                                ) {

                                    return null;

                                }


                                return (

                                    <FilaSeleccionada
                                        key={
                                            actividad.id
                                        }
                                    >


                                        <NombreActividadSeleccionada>

                                            {
                                                obtenerNombreActividad(
                                                    actividad
                                                )
                                            }

                                        </NombreActividadSeleccionada>


                                        <BotonEliminarSeleccionada

                                            type="button"

                                            onClick={
                                                (e) =>
                                                    eliminarActividad(
                                                        e,
                                                        actividad.id
                                                    )
                                            }

                                        >

                                            Eliminar

                                        </BotonEliminarSeleccionada>


                                        <ContadorActividad>


                                            <BotonContador

                                                type="button"

                                                onClick={
                                                    (e) =>
                                                        actualizarContador(
                                                            e,
                                                            actividad.id,
                                                            'disminuir'
                                                        )
                                                }

                                            >

                                                −

                                            </BotonContador>


                                            <ValorContador>

                                                {
                                                    actividad.contador
                                                }

                                            </ValorContador>


                                            <BotonContador

                                                type="button"

                                                onClick={
                                                    (e) =>
                                                        actualizarContador(
                                                            e,
                                                            actividad.id,
                                                            'aumentar'
                                                        )
                                                }

                                            >

                                                +

                                            </BotonContador>


                                        </ContadorActividad>


                                        <ControlesOrden>


                                            {
                                                index ===
                                                0
                                                    ?
                                                    null
                                                    :

                                                    <BotonOrden

                                                        type="button"

                                                        title="Subir posición"

                                                        onClick={
                                                            (e) =>
                                                                modificoOrden(
                                                                    e,
                                                                    index,
                                                                    'disminuir'
                                                                )
                                                        }

                                                    >

                                                        ↑

                                                    </BotonOrden>
                                            }


                                            {
                                                index ===
                                                actividadesSeleccionadas.length -
                                                    1
                                                    ?
                                                    null
                                                    :

                                                    <BotonOrden

                                                        type="button"

                                                        title="Bajar posición"

                                                        onClick={
                                                            (e) =>
                                                                modificoOrden(
                                                                    e,
                                                                    index,
                                                                    'aumentar'
                                                                )
                                                        }

                                                    >

                                                        ↓

                                                    </BotonOrden>
                                            }


                                        </ControlesOrden>


                                    </FilaSeleccionada>

                                );

                            }
                        )
                }


            </ListaSeleccionadas>


            <BarraAgendado>


                <CampoAgendado>


                    <LabelAgendado>

                        Agendar sesión para la fecha

                    </LabelAgendado>


                    <InputFechaAgendado

                        type="date"

                        name="fechaSesion"

                        value={
                            fechaSesion
                        }

                        onChange={
                            e =>
                                setFechaSesion(
                                    e.target.value
                                )
                        }

                    />


                </CampoAgendado>


                <CampoAgendado>


                    <LabelAgendado>

                        Cantidad de ejercicios

                    </LabelAgendado>


                    <ValorAgendado>

                        {
                            actividades.filter(
                                actividad =>
                                    actividad.seleccionado ===
                                    true
                            ).length
                        }

                    </ValorAgendado>


                </CampoAgendado>


                <CampoAgendado>


                    <LabelAgendado>

                        Tiempo de sesión

                    </LabelAgendado>


                    <ValorAgendado>

                        {
                            tiempoSesion
                        }

                    </ValorAgendado>


                </CampoAgendado>


                <BotonAgendarActividad

                    type="button"

                    onClick={
                        (e) =>
                            actividadesAgendar(
                                e
                            )
                    }

                >

                    Agendar

                </BotonAgendarActividad>


            </BarraAgendado>


        </ContenedorSeleccionadas>

    );

};


export default SeleccionarActividadesSeleccionadas;